// TS bridge to the custom PhotoScan Swift plugin.
//
// Provides the date-range PHPhotoLibrary scan we cannot do from the webview.
// On web (or pre-plugin builds) the calls reject and callers fall back to the ad-hoc
// @capacitor/camera pickImages flow (see photos.ts).
import { registerPlugin } from "@capacitor/core";

export type PhotoScanAuthStatus =
  | "granted"
  | "limited"
  | "denied"
  | "restricted"
  | "prompt"
  | "unknown";

export type PhotoScanAsset = {
  localIdentifier: string;
  mediaType: "image" | "video";
  creationDate?: string;     // ISO
  latitude?: number;
  longitude?: number;
  altitude?: number;
  pixelWidth: number;
  pixelHeight: number;
  durationSeconds?: number;  // videos only
};

export interface PhotoScanPlugin {
  requestPermission(): Promise<{ status: PhotoScanAuthStatus }>;
  scan(opts: { start: string; end: string }): Promise<{ assets: PhotoScanAsset[] }>;
  getThumbnail(opts: { localIdentifier: string; size?: number }): Promise<{ base64: string }>;
  streamAsset(opts: { localIdentifier: string }): Promise<{
    path: string;
    filename: string;
    mimeType: string;
  }>;
  presentLimitedPicker(): Promise<{ supported?: boolean; message?: string } | void>;
}

export const PhotoScan = registerPlugin<PhotoScanPlugin>("PhotoScan");

export async function photoScanAvailable(): Promise<boolean> {
  try {
    await PhotoScan.requestPermission();
    return true;
  } catch {
    return false;
  }
}
